import React from 'react';

import Icons from '@/core/components/Icons';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

export const LocationLoader = () => {
  const { t } = useTranslationContext(['common']);

  return (
    <div aria-label={t('buttons.spinner.aria-valuetext', { ns: 'common' })} className="flex w-full items-center justify-center py-4">
      <Icons icon="spinner" color="button-default" size="24" />
    </div>
  );
};
